<script setup lang="ts">
const { registerData } = storeToRefs(useRegisterStore());

const { isLudopathyValidationEnabled } = useFeatureFlagsNew();

// const bonusConsent = `Aceito receber meu bônus de boas vindas de até R$7000,00 no meu primeiro depósito.`;
</script>

<template>
  <form class="flex gap-4 flex-col registerFields">
    <section :class="$style.checkboxSection">
      <BaseFormCheckbox
        v-model="registerData.optIn"
        :label="$t('multiStepRegister.step4.termsAgreement')"
        value="termsAgreement"
      />
    </section>

    <section
      v-if="isLudopathyValidationEnabled"
      :class="$style.checkboxSection"
    >
      <BaseFormCheckbox
        v-model="registerData.optIn"
        :label="$t('auth.register.ludopathy.optin')"
        value="ludopathy"
      />
    </section>

    <section :class="$style.checkboxSection">
      <BaseFormCheckbox
        v-model="registerData.optIn"
        :label="$t('multiStepRegister.step4.declarationOfTruth')"
        value="declarationOfTruth"
      />
    </section>

    <section :class="$style.checkboxSection">
      <BaseFormCheckbox
        v-model="registerData.optIn"
        :label="$t('multiStepRegister.step4.notificationConsent')"
        value="notificationConsent"
      />
    </section>

    <AuthRegisterMultiStepWarningAlert class="mt-1" />

    <!--    <section :class="[$style.checkboxSection, $style.highlighted]">-->
    <!--      <BaseFormCheckbox-->
    <!--        v-model="registerData.optIn"-->
    <!--        :label="bonusConsent"-->
    <!--        value="bonusConsent"-->
    <!--      />-->
    <!--      <div class="ml-4 p-2 bg-primary rounded-full text-2xs">-->
    <!--        <NuxtIcon name="gift" />-->
    <!--      </div>-->
    <!--    </section>-->
  </form>
</template>

<style module lang="scss">
.checkboxSection {
  @apply px-4 py-3 bg-black/20 rounded-lg flex items-start;

  &.highlighted {
    @apply shadow-primary/20 bg-primary/20;
    box-shadow: 0 0 12px var(--tw-shadow-color);
  }

  &.hasError {
    box-shadow: 0 0 200px inset rgba(255, 0, 0, 0.1);
  }

  p {
    @apply text-2xs leading-4;
  }

  a {
    @apply text-primary underline cursor-pointer whitespace-nowrap;
  }

  b {
    @apply font-semibold text-primary;
  }
}
</style>
